import contactSideBarFields from 'molecules/ContactSideBar/config';

import type { Input } from '@builder.io/sdk';

const dataPrivacyFormFields = [
  {
    name: 'title',
    type: 'string',
  },
  {
    name: 'formId',
    type: 'string',
  },
  {
    name: 'outline',
    type: 'boolean',
    defaultValue: 'false',
  },
  {
    name: 'addPadding',
    type: 'boolean',
    defaultValue: 'false',
  },
  {
    name: 'formFields',
    type: 'list',
    subFields: [
      {
        name: 'type',
        type: 'string',
        enum: ['text', 'email', 'tel', 'textarea'],
        defaultValue: 'text',
      },
      {
        name: 'fieldName',
        type: 'string',
      },
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'required',
        type: 'boolean',
        defaultValue: false,
      },
    ],
  },
  {
    name: 'redirect_url',
    type: 'object',
    subFields: [
      {
        name: 'dev_url',
        friendlyName: 'dev',
        type: 'string',
      },
      {
        name: 'qa_url',
        friendlyName: 'qa',
        type: 'string',
      },
      {
        name: 'staging_url',
        friendlyName: 'uat',
        type: 'url',
      },
      {
        name: 'production_url',
        friendlyName: 'production',
        type: 'url',
      },
    ],
  },
  {
    name: 'contactSideBar',
    type: 'object',
    subFields: [...contactSideBarFields],
  },
] as const satisfies DeepReadonly<Input[]>;

const dataPrivacyFormConfig = {
  name: 'Data Privacy Form',
  inputs: dataPrivacyFormFields,
};

export type dataPrivacyFormProps = GenerateBuilder<typeof dataPrivacyFormFields>;

export default dataPrivacyFormConfig;
